var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 발급된 가상계좌가 없습니다. ")]), _c('v-card-actions', {
    staticClass: "justify-center pt-0"
  }, [_c('v-btn', {
    staticClass: "px-6",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('post');
      }
    }
  }, [_vm._v("가상계좌 발급받기")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }